import mutations from './mutations'

export const user = {
  state: () => ({}),
  mutations,
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js